export let pageInit

export function initPage(init) {
    pageInit = init

    init.$init = Promise.all([Promise.resolve(init.formPresets), Promise.resolve(init.dataFormatters)]).then(
        ([presets, formatters]) => {
            init.formPresets = presets ?? {}
            init.dataFormatters = formatters ?? {}
            init.__$ = true
        },
    )

    return {
        ...pageInit,
        install(app) {
            app.config.globalProperties.$file = pageInit.fileDownload
            app.config.globalProperties.$preview = pageInit.filePreview
        },
    }
}

export function useCoreCtx() {
    return pageInit
}
